/**
 * Frontend mirror of `/app/backend/badges.py`. KEEP IN SYNC — backend
 * `valid_badge_id` rejects anything not in this list (returns 422).
 *
 * `color` is consumed by `BadgeChip` (renders a Tailwind class set) and
 * `icon` maps to a lucide-react icon name.
 */
import { Check, Star, Crown, Shield, Trophy } from "lucide-react";

export const BADGE_REGISTRY = {
  none: { id: "none", label: null, color: null, icon: null },
  standard: { id: "standard", label: "Standard", color: "slate", icon: "check" },
  preferred: { id: "preferred", label: "Preferred", color: "blue", icon: "star" },
  elite: { id: "elite", label: "Elite", color: "purple", icon: "crown" },
  // Note: the dict key + preset id stay "certified" as a stable identifier so
  // upstream data referencing this preset doesn't break. User-facing label is
  // "Verified" because we haven't built a real certification flow yet — same
  // language used by the chip in BookingWizard's provider match list and by
  // the default <CertifiedBadge /> render.
  certified: { id: "certified", label: "Verified", color: "green", icon: "shield" },
  top_rated: { id: "top_rated", label: "Top Rated", color: "orange", icon: "trophy" },
};

export const BADGE_OPTIONS = [
  "none",
  "standard",
  "preferred",
  "elite",
  "certified",
  "top_rated",
];

// Tailwind class set per badge color. Picked for AA contrast on both light
// and dark surfaces.
const COLOR_CLASSES = {
  slate: "bg-slate-200 text-slate-800 dark:bg-slate-700 dark:text-slate-100",
  blue: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200",
  purple: "bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-200",
  green: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200",
  orange: "bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-200",
};

const ICONS = { check: Check, star: Star, crown: Crown, shield: Shield, trophy: Trophy };

export function badgeMeta(badgeId) {
  return BADGE_REGISTRY[badgeId] || BADGE_REGISTRY.none;
}

export function badgeColorClasses(color) {
  return COLOR_CLASSES[color] || "bg-pp-surface2 text-pp-text";
}

export function badgeIconComponent(iconName) {
  return ICONS[iconName] || null;
}
